import { render, staticRenderFns } from "./ProgramSettingsFormWrapper.vue?vue&type=template&id=f6411320&scoped=true&lang=pug&"
import script from "./ProgramSettingsFormWrapper.vue?vue&type=script&lang=js&"
export * from "./ProgramSettingsFormWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ProgramSettingsFormWrapper.vue?vue&type=style&index=0&id=f6411320&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6411320",
  null
  
)

export default component.exports